import {
    buttonClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const FeaturedItemsdWrapper: StyleRule = () => ({
    marginBottom: pxToRem(60),
});

export const TileGrid: StyleRule<{ twoColumns: boolean }> = ({
    twoColumns,
}) => {
    if (twoColumns) {
        return {
            gap: pxArrayToRem([50, 6]),
        };
    }

    return {
        gap: pxArrayToRem([50, 0]),
    };
};

export const ButtonRow: StyleRule = () => ({
    padding: pxArrayToRem([60, 18, 0]),
});

export const LoadMore: StyleRule = () => ({
    ['&.' + buttonClassName]: {
        ['& .' + labelClassName]: {
            textTransform: 'uppercase',
        },
    },
});
